// Daily plays reset at 06:00 device-local time (PLAN Q15): a play-day runs 06:00–05:59.
export const RESET_HOUR = 6

export function playDay(ms: number, timeZone?: string): string {
  const f = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' })
  return f.format(ms - RESET_HOUR * 3600_000)
}
